import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Device, DwtService} from 'src/app/share/services/dwt/dwt.service';
import {WebTwain} from 'dwt/dist/types/WebTwain';
import {ThumbnailViewer} from 'dwt/dist/types/WebTwain.Viewer';
import {Observable, Subscription} from 'rxjs';
import Dynamsoft from 'dwt';
import {NgbModal, NgbModalRef,} from '@ng-bootstrap/ng-bootstrap';
import {CommonService} from 'src/app/share/services/common/common.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ConfirmationPopupComponent } from 'src/app/share/popups/confirmation-popup/confirmation-popup.component';
import { StorageService } from 'src/app/share/services/storage-service/storage.service';
import { StorageKeys } from 'src/app/share/enums/storage.enum';


@Component({
    selector: 'app-dwt',
    templateUrl: './dwt.component.html',
    styleUrl: './dwt.component.scss',
    standalone: false
})
export class DwtComponent implements OnInit, OnDestroy {
  @Input() events: Observable<void>;
  @Output() closePopupEvent: EventEmitter<any> = new EventEmitter<any>();
  /**
   * Variable that refer to the open modal dialog.
   */
  private modalRef: NgbModalRef;
  /**
   * A few subscriptions and observables to get information from dwt.service
   */
  private eventsSubscription: Subscription;
  private barcodeReadingSubscription: Subscription;
  private bufferSubscription: Subscription;
  private bufferObservable: Observable<string>;
  private generalSubscription: Subscription;
  /**
   * Two WebTwain objects doing all the job.
   */
  protected DWObject: WebTwain;
  protected VideoContainer: WebTwain;
  /**
   * Global variables and status flags.
   */
  public bWin = true;
  public dwtMounted = false;
  public bMobile: boolean;
  public bUseCameraViaDirectShow: boolean;
  public containerId = "dwtcontrolContainer";
  public videoContainerId = "videoContainer";
  public editorShown = false;
  public devices: Device[];
  public showDevices: boolean = false;
  public deviceName: string = "Choose...";
  public thumbnail: ThumbnailViewer;
  public emptyBuffer: boolean = true;
  public zones: Zone[] = [];
  public mainViewerPos = { x: 0, y: 0 };
  public videoPlaying: boolean = false;
  public showVideoText: string = "Show Video";
  public instantError: string = "There is no image in buffer!";
  public outputMessages: Message[] = [];
  public historyMessages: Message[] = [];
  public bDontScrollMessages: boolean = true;
  public thumbnailURLs: ThumbnailItem[] = [];
  public draggedIndex: number | null = null;
  private isUpdatingThumbnails = false;
  private isDragging = false;
  private isSelectingPage = false;
  private thumbnailUpdateTimeout: any = null;
  private thumbnailCache = new Map<number, ThumbnailItem>();
  private thumbnailStableTimeout: any = null;

  /**
   * For Barcode Reading.
   */
  public barcodeResult: Observable<any>;
  public barcodeRects: any
  public barcodeRectsOnCurrentImage: Array<BarcodeRectToShow> = [];
  public barcodeButtonText = "Read";
  /**
   * Buffer info
   */
  public current: 0;
  public count: 0;
  /**
   * Options.
   */
  public formatsToImport = {
    JPG: true,
    PNG: true,
    TIF: false,
    PDF: false
  };
  public scanOptions = {
    IfShowUI: true,
    PixelType: "1",// "gray"
    Resolution: 200,
    IfFeederEnabled: false,
    IfDuplexEnabled: false,
    IfDisableSourceAfterAcquire: true,
    IfGetImageInfo: false,
    IfGetExtImageInfo: false,
    extendedImageInfoQueryLevel: 0,
    PageSize: 1
  };
  public cameraOptions: any[] = [];
  public currentOption = "";
  public currentOptionItems: any[] = [];
  public currentItem = "";
  public showRangePicker = false;
  public rangePicker = null;
  public barcodeReaderOptions = {
    Symbologies: {
      All: true,
      Linear: true,
      QRCode: true,
      Pdf: true,
      DM: true,
      Aztec: true,
      GS1Databar: true,
      Maxi: true,
      Patch: true,
      Postal: true,
      Dot: true,
      GS1Composite: true
    },
    Mode: "balance",
    showRects: true,
    rectShowingTime: 3
  };
  public saveOptions: any = {
    outPutType: "File",
    outPutFormat: "PDF",
    multiPage: false,
    fileName: "CreatedByDynamsoft",
    upload: true,
    buttonText: "Upload",
    indices: []
  };
  public saveResults: any = {
    blob: [],
    blobURL: [],
    base64String: [],
    savedFiles: [],
    uploadedFiles: [],
    base64ButtonText: [],
    saveFileText: [],
    blobToShow: null
  }
  materialEnabled: boolean = false;

  constructor(protected dwtService: DwtService,
    private modalService: NgbModal,
    private commonService: CommonService,
    private sanitizer: DomSanitizer,
    private readonly storageService: StorageService
  ) {
    this.initDWT();
    this.bMobile = this.dwtService.runningEnvironment?.bMobile;
  }
  ngOnInit() {
    this.eventsSubscription = this.events?.subscribe(
      (args: any) => {
        if (args.type)
          switch (args.type) {
            case "resize":
              if (this.editorShown)
                break;
              else
                if (this.updateViewer()) {
                  this.showRects();
                }
              break;
            default: break;
          }
      }
    );
    this.barcodeResult = this.dwtService.barcodeSubject;
    this.bufferObservable = this.dwtService.bufferSubject;
    this.barcodeReadingSubscription = this.barcodeResult?.subscribe(
      result => {
        if (result.done) {
          this.barcodeButtonText = "Done, Click to Read Again!";
        }
        if (result.imageIds) {
          // Barcode rects have been returned
          this.barcodeRects = result;
          this.showRects();
        } else if (result.length > 0 && result[0].type !== "") {
          for (const item of result)
            this.handleOutPutMessage(item.text,item.type, false, false);
        }
      }
    );
    this.bufferSubscription = this.bufferObservable?.subscribe(
      bufferStatus => {
        this.emptyBuffer = false;
        switch (bufferStatus) {
          case "empty":
            this.emptyBuffer = true;
            break;
          case "changed":
            this.barcodeRectsOnCurrentImage = [];
            this.zones = [];
            if (!this.isSelectingPage && !this.isDragging) {
                this.scheduleThumbnailUpdate();
            }
            break;
          default:
            if (!this.isSelectingPage && !this.isDragging) {
              this.scheduleThumbnailUpdate();
            }
            break;
        }
        if (this.emptyBuffer) {
          this.thumbnailURLs = [];
          this.showMessage("There is no image in buffer!");
        } else { this.clearMessage() }
      }
    );
    this.generalSubscription = this.dwtService.generalSubject?.subscribe(
      input => {
        if (input?.type) {
          switch (input.type) {

            case "deviceName":
              this.deviceName = input.deviceName;
              break;
            case "cameraOptions":
              this.cameraOptions = input;

              break;
            default: break;
          }
        }
      }
    );

    setTimeout(()=>{
      this.getDevices();
  }, 3000);
    this.materialEnabled = !!this.storageService.getDataFromLocalStorage(StorageKeys.PREFERENCES)?.material?.enabled;
    if (this.materialEnabled) {
      this.scanOptions.IfFeederEnabled = true;
      this.scanOptions.PixelType = "2";
    }
  }
  ngOnDestroy() {
    this.eventsSubscription?.unsubscribe();
    this.bufferSubscription?.unsubscribe();
    this.generalSubscription?.unsubscribe();
    this.barcodeReadingSubscription?.unsubscribe();
    this.dwtService.unMountDWT()?.then(
      _ =>
        this.dwtService.unMountVideoContainer());
    if (this.thumbnailUpdateTimeout) {
      clearTimeout(this.thumbnailUpdateTimeout);
    }
  }
  clearMessage() {
    this.instantError = "";
  }
  showMessage(msg: string) {
    this.instantError = msg;
  }
  /**
   * Supporting functions.
   */
  isScannerFilter(device: Device) {
    return device.type === "scanner";
  }
  isCameraFilter(device: Device) {
    return device.type === "camera";
  }
  toggleCheckAll() {
    let _symbologies: any = this.barcodeReaderOptions.Symbologies;
    for (let key in _symbologies) {
      if (_symbologies.hasOwnProperty(key)) {
        if (key !== "All")
          _symbologies[key] = !_symbologies["All"];
      }
    }
  }
  showRects() {
    // Clear rects
    this.barcodeRectsOnCurrentImage = [];
    if (this.barcodeRects === undefined || this.barcodeRects.imageIds === undefined) return;
    if (this.barcodeRects.imageIds.length === 0 || this.barcodeRects.imageIds.length !== this.barcodeRects.rects.length)
      //invalid rects
      return;
    for (let i = 0; i < this.barcodeRects.imageIds.length; i++) {
      let currentIndex: any = this.DWObject?.ImageIDToIndex(this.barcodeRects.imageIds[i]);
      if (this.DWObject?.CurrentImageIndexInBuffer === currentIndex) {
        let rectsOnOnePage = this.barcodeRects.rects[i];
        let mainViewer = <HTMLDivElement>document.querySelector("#" + this.containerId + " .dvs-viewer-main");
        let zoom = 0,
          viewerWidth = mainViewer?.offsetWidth,
          viewerHeight = mainViewer?.offsetHeight,
          imageWidth = this.DWObject?.GetImageWidth(currentIndex),
          imageHeight = this.DWObject?.GetImageHeight(currentIndex);
        this.mainViewerPos.y = mainViewer?.getBoundingClientRect().top;
        this.mainViewerPos.x = mainViewer?.getBoundingClientRect().left;
        if (viewerWidth >= imageWidth && viewerHeight >= imageHeight) {
          zoom = 1;
        } else if (viewerWidth / viewerHeight >= imageWidth / imageHeight) {
          zoom = viewerHeight / imageHeight;
        } else {
          zoom = viewerWidth / imageWidth;
        }
        for (const rect of rectsOnOnePage) {
          let leftBase = 1 + viewerWidth / 2 - imageWidth / 2 * zoom;
          let topBase = 1 + viewerHeight / 2 - imageHeight / 2 * zoom;
          let left = leftBase + rect.x * zoom;
          let top = topBase + rect.y * zoom;
          let width = rect.w * zoom;
          let height = rect.h * zoom;
          this.barcodeRectsOnCurrentImage.push({ x: left, y: top, w: width, h: height });
        }
        break;
      }
    }
  }
  updateViewer() {
    if (this.DWObject) {
      this.DWObject.Viewer.width = "100%";
      this.DWObject.Viewer.height = "100%";
      return true;
    }
    else
      return false;
  }
  unBindViewer() {
    if (this.DWObject?.Viewer.unbind()) {
      let container: any = document.getElementById(this.containerId);
      while (container.firstChild) {
        container.removeChild(container.lastChild);
      }
      if (!this.emptyBuffer)
        this.clearMessage();
      return true;
    } else {
      this.showMessage(this.DWObject?.ErrorString);
      return false;
    }
  }
  bindViewer() {
    this.DWObject?.Viewer.bind(<HTMLDivElement>document.getElementById(this.containerId));
    this.DWObject.Viewer.width = "100%";
    this.DWObject.Viewer.height = "100%";
    if (this.DWObject.Viewer) {
      this.DWObject.Viewer.show();
      this.DWObject.Viewer.off('imageRightClick');
      this.DWObject.Viewer.on('pageAreaSelected', (nImageIndex, rect) => {
        if (rect.length > 0) {
          this.clearMessage();
          let currentRect = rect[rect.length - 1];
          if (rect.length > this.zones.length + 1) {
            this.showMessage("Impossible Area selected!");
            return;
          }
          if (rect.length == 1)
            this.zones = [];
          if (this.zones.length + 1 === rect.length)
            this.zones.push({ x: currentRect.x, y: currentRect.y, width: currentRect.x + currentRect.width, height: currentRect.y + currentRect.height, index: nImageIndex });
          else
            this.zones.splice(rect.length - 1, 1, { x: currentRect.x, y: currentRect.y, width: currentRect.x + currentRect.width, height: currentRect.y + currentRect.height, index: nImageIndex });
        }
      });
      this.DWObject.Viewer.on('OnImageAreaDeSelected', () => {
        this.clearMessage(); this.zones = [];
      });
      this.DWObject.Viewer.cursor = this.bMobile ? 'pointer' : 'crosshair';
      this.DWObject.Viewer.showPageNumber = true;
      if (document.getElementById(this.containerId + "-fileInput"))
        // Only allow one such input on the page
        return;
      let WASMInput = document.createElement("input");
      WASMInput.style.position = "fixed";
      WASMInput.style.top = "-1000px";
      WASMInput.setAttribute("multiple", "multiple");
      WASMInput.setAttribute("id", this.containerId + "-fileInput");
      WASMInput.setAttribute("type", "file");
       WASMInput.onchange = evt => {
        let _input: any = <HTMLInputElement>evt.target;
        this.dwtService.load(_input.files)
          .then(_ => {
            this.closeModal(true);
            _input.value = '';
          });
      };
      document.getElementById(this.containerId)?.parentElement?.appendChild(WASMInput);
    }
    else {
      console.log(this.DWObject.ErrorString);
    }
  }
  initDWT(): void {
    this.DWObject ;
    this.dwtService.initialize();
    this.dwtService.mountDWT()
      ?.then(
        obj => {
          this.DWObject = obj;
          this.bWin = this.dwtService.runningEnvironment.bWin;
          this.bUseCameraViaDirectShow = this.dwtService.bUseCameraViaDirectShow;
          this.dwtMounted = true;
          this.dwtService.mountVideoContainer()
            .then(containerDWT => {
              this.VideoContainer = containerDWT;
            }, err => this.showMessage(err));
          setTimeout(() => {
            this.bindViewer();
            this.DWObject.Viewer.pageMargin = 10;
          }, 0);
        },
        err => this.showMessage(err));
  }
  openModal(content: any, type?: string) {
    this.modalRef = this.modalService.open(content, {
      backdrop: "static",
      centered: true,
      beforeDismiss: (): boolean => {
        switch (type) {
          case "acquire":
            this.deviceName = "Choose...";
            return true;
          case "camera":
            if (this.videoPlaying) {
              if (this.bUseCameraViaDirectShow) {
                this.showMessage("Please stop video first!");
                return false;
              }
              else {
                return true;

              }
            } else {
              this.deviceName = "Choose...";
              return this.VideoContainer.Viewer.unbind();
            }
          case "barcode":{
            let __interval = setInterval(
              () => {
                this.barcodeReaderOptions.rectShowingTime--;
                if (this.barcodeReaderOptions.rectShowingTime === 0) {
                  this.barcodeReaderOptions.rectShowingTime = 3;
                  this.barcodeReaderOptions.showRects = false;
                  clearInterval(__interval);
                }
              }, 1000);
            this.barcodeButtonText = "Read";
            this.handleOutPutMessage("", "", true, true);
            return true;
          }
          case "save":
            this.saveOptions.indices = [];
            return true;

          default:
            return true;

        }
      }
    });
    this.modalRef.result.then((result) => {//close
    }, (reason) => {//dismiss, reset modal dialogs
      if (this.emptyBuffer)
        this.showMessage("There is no image in buffer!");
      this.saveResults = {
        blob: [],
        blobURL: [],
        base64String: [],
        savedFiles: [],
        uploadedFiles: [],
        base64ButtonText: [],
        saveFileText: [],
        blobToShow: null
      };
    });
    switch (type) {

      case "camera":
        let makeSureDIVExists = () => {
          let container = <HTMLDivElement>document.getElementById(this.videoContainerId);
          if (container) {
            if (this.VideoContainer === null) {
              this.showMessage("No Video Container!");
              return;
            }
            container.style.height = "100%";
            this.cameraOptions = [];
            this.currentOption = "";
            this.currentItem = "";
            this.currentOptionItems = [];
            this.VideoContainer.Viewer.bind(<HTMLDivElement>document.getElementById(this.videoContainerId));
            this.VideoContainer.Viewer.width = "100%";
            this.VideoContainer.Viewer.height = "100%";
            this.VideoContainer.Viewer.show();
          }
          else{
            setTimeout(() => makeSureDIVExists(), 10);
          }
        };

        makeSureDIVExists();
        this.clearMessage();
        this.dwtService.getDevices(true)
          .then(result => { this.devices = result; this.showDevices = true; }, err => this.showMessage(err.message));
        this.deviceName = "Choose...";
        break;
      case "acquire":
        this.clearMessage();
        this.dwtService.getDevices(false)
          .then(result => { this.devices = result; this.showDevices = true; },
            err => {
              console.log('error', err.message)
              this.showMessage(err.message)
            });
        this.deviceName = "Choose...";
        break;
      case "barcode":
        if (!this.emptyBuffer)
          this.clearMessage();
        this.barcodeReaderOptions.showRects = true;
        break;
      case "save":{
        if (!this.emptyBuffer)
          this.clearMessage();
        let selectedIndices = this.DWObject.SelectedImagesIndices;
        let count = this.DWObject.HowManyImagesInBuffer;
        for (let i = 0; i < count; i++)
          this.saveOptions.indices.push({ number: i, selected: !!selectedIndices.find(o => { return o == i; }) });
      }
        break;
      default: break;
    }
  }

  getDevices(){
    this.clearMessage();
    this.dwtService.getDevices(false)
      ?.then(result => {
        this.devices = result;
        this.showDevices = true;
       },
        err => {
          console.log('error', err.message)
          this.showMessage(err.message)
        });
    this.deviceName = "Choose...";
  }

  closeModal(close: boolean) {
    if (this.modalRef === undefined) return;
    if (close)
      this.modalRef.close();
    else
      this.modalRef.dismiss();
  }
  handleDeviceChange(deviceType: string) {
    if (this.deviceName === "" || this.deviceName === "Choose...")
      return;
    this.dwtService.selectADevice(this.deviceName)
      ?.then(
        done => done ? this.openADevice(deviceType) : this.showMessage("Device selecting failed!"),
        error => typeof error === "string" ? this.showMessage(error) : this.showMessage("Device selecting failed!"));
  }
  openADevice(deviceType: string) {
    this.clearMessage();

  }
  acquire() {
    this.scan();
  }
  acquireFromCamera() {
    this.dwtService.acquire()
      ?.then(_ => {
        this.showMessage("Captured successfully!"); setTimeout(() => {
          this.clearMessage();
        }, 3000);
      }, err => this.showMessage(err));
  }
  scan() {
    this.dwtService.acquire(this.scanOptions)
      ?.then(() => {
        this.closeModal(true);
        if (!this.emptyBuffer)
          this.clearMessage();
      }, err => this.showMessage(err));
  }
  load() {
    this.dwtService.load()
      ?.then(() => {
        this.closeModal(true);
        if (!this.emptyBuffer)
          this.clearMessage();
      }, err => this.showMessage(err));
  }
  showEditor() {
    this.DWObject.Viewer.createImageEditor().show();
    this.DWObject.RegisterEvent('CloseImageEditorUI', () => {
      this.editorShown = false;
    });
    this.editorShown = true;
  }
  readBarcode() {
    if (this.outputMessages.length > 0) {
      this.handleOutPutMessage("", "", true, true);
      this.barcodeButtonText = "Read";
      return;
    }
    this.barcodeButtonText = "Reading...";
    let formatId = 0, formatId2 = 0;
    formatId += this.barcodeReaderOptions.Symbologies.Aztec ? Dynamsoft.DBR.EnumBarcodeFormat.BF_AZTEC : 0;
    formatId += this.barcodeReaderOptions.Symbologies.DM ? Dynamsoft.DBR.EnumBarcodeFormat.BF_DATAMATRIX : 0;
    formatId2 += this.barcodeReaderOptions.Symbologies.Dot ? Dynamsoft.DBR.EnumBarcodeFormat_2.BF2_DOTCODE : 0;
    formatId += this.barcodeReaderOptions.Symbologies.GS1Composite ? Dynamsoft.DBR.EnumBarcodeFormat.BF_GS1_COMPOSITE :0;
    formatId += this.barcodeReaderOptions.Symbologies.GS1Databar ? Dynamsoft.DBR.EnumBarcodeFormat.BF_GS1_DATABAR: 0;
    formatId += this.barcodeReaderOptions.Symbologies.Linear ? Dynamsoft.DBR.EnumBarcodeFormat.BF_ONED: 0;
    formatId += this.barcodeReaderOptions.Symbologies.Maxi ? Dynamsoft.DBR.EnumBarcodeFormat.BF_MAXICODE: 0;
    formatId += this.barcodeReaderOptions.Symbologies.Patch ? Dynamsoft.DBR.EnumBarcodeFormat.BF_PATCHCODE: 0;
    formatId += this.barcodeReaderOptions.Symbologies.Pdf ? Dynamsoft.DBR.EnumBarcodeFormat.BF_PDF417: 0;
    formatId += this.barcodeReaderOptions.Symbologies.QRCode ? Dynamsoft.DBR.EnumBarcodeFormat.BF_QR_CODE: 0;

      formatId2 += this.barcodeReaderOptions.Symbologies.Postal ?
      Dynamsoft.DBR.EnumBarcodeFormat_2.BF2_POSTALCODE
      + Dynamsoft.DBR.EnumBarcodeFormat_2.BF2_POSTNET
      + Dynamsoft.DBR.EnumBarcodeFormat_2.BF2_AUSTRALIANPOST
      + Dynamsoft.DBR.EnumBarcodeFormat_2.BF2_USPSINTELLIGENTMAIL
      + Dynamsoft.DBR.EnumBarcodeFormat_2.BF2_RM4SCC
      + Dynamsoft.DBR.EnumBarcodeFormat_2.BF2_PLANET
      :  0;
    this.barcodeRectsOnCurrentImage.splice(0, this.barcodeRectsOnCurrentImage.length);
    this.dwtService.readBarcode({ formatId: formatId, formatId2: formatId2, zones: this.zones });
  }
  hideBarcodeTextResults() {
    this.barcodeButtonText = "Read";
    this.handleOutPutMessage("", "", true, true);
  }
  handleOutPutMessage(message: string, type: string, bReset: boolean, bNoScroll: boolean) {
    let _noScroll = false, _type = "info";
    if (type)
      _type = type;
    if (_type === "httpResponse") {
      let msgWindow: any = window.open("", "Response from server", "height=500,width=750,top=0,left=0,toolbar=no,menubar=no,scrollbars=no, resizable=no,location=no, status=no");
      msgWindow?.document.writeln(message);
    } else {
      if (bNoScroll)
        _noScroll = true;
      if (bReset) {
        this.outputMessages = this.historyMessages.concat(this.outputMessages);
        this.historyMessages = [];
      }
      else {
        this.outputMessages.push({ time: (new Date()).getTime(), text: message, type: _type });
      }
      this.bDontScrollMessages = _noScroll;
    }
  }
  handleOptionChange() {
    for (const Options of this.cameraOptions) {
      if (Options.name === this.currentOption) {
        Options.current = true;
      }
      else {
        Options.current = false
      }
    }

    for (const items of this.currentOptionItems) {
      if (items.checked) {
        this.currentItem = items.value;
        break;
      }
    }
  }

  handleItemPicked() {
     for(const item of this.currentOptionItems){
      if(this.currentItem == item.value){
        item.checked =true;
      }
      else{
        item.checked =false;
      }
  }
  }

  outPutTypeChanged(newType: any) {
    switch (newType) {
      case "File":
        if (this.saveOptions.upload) {
          this.saveOptions.buttonText = "Upload"
        }
        else {
          this.saveOptions.buttonText = "Save"
        }
        break;
      case "Blob":
        this.saveOptions.buttonText = "Save As Blob";
        break;
      case "Base64":
        this.saveOptions.buttonText = "Save As Base64";
        break;
      default: break;
    }
  }
  getImageType(formatString: string): number {
    formatString = "IT_" + formatString;
    let imageType = 4;
    Object.entries(Dynamsoft.DWT.EnumDWT_ImageType).forEach(_type => {
      if (_type[0] === formatString)
        imageType = <number>_type[1];
    });
    return imageType;
  }
  copyBase64String(indexOfString: any) {
    if (navigator.clipboard) {
      if (this.saveResults.base64String[indexOfString] === "")
        this.showMessage("No resulting String!");
      navigator.clipboard.writeText(this.saveResults.base64String[indexOfString])
        .then(_ => {
          this.saveResults.base64ButtonText[indexOfString] = "Copied!";
          setTimeout(() => {
            this.saveResults.base64String.splice(indexOfString, 1);
            this.saveResults.base64ButtonText.splice(indexOfString, 1);
          }, 3000);
        });
    } else {
      this.showMessage("Can not use the clipboard! Please use HTTPS.");
    }
  }
  copyFilePath(indexOfString: any) {
    if (navigator.clipboard) {
      if (this.saveResults.saveFileText[indexOfString] === "")
        this.showMessage("No resulting String!");
      navigator.clipboard.writeText(this.saveResults.savedFiles[indexOfString].path)
        .then(_ => {
          this.saveResults.saveFileText[indexOfString] = "Copied!";
          setTimeout(() => {
            this.saveResults.savedFiles.splice(indexOfString, 1);
            this.saveResults.saveFileText.splice(indexOfString, 1);
          }, 3000);
        });
    } else {
      this.showMessage("Can not use the clipboard! Please use HTTPS.");
    }
  }
  handleMultiPageCheck() {
    if (this.saveOptions.multiPage) {
      if (this.DWObject.SelectedImagesIndices.length === 1) {
        this.saveOptions.indices.forEach((value: any, index: number, arr: any) => { value.selected = true; arr[index] = value; });
        this.DWObject.SelectAllImages();
      }
    } else {
      if (this.DWObject?.SelectedImagesIndices.length > 1)
        this.DWObject.SelectImages([this.DWObject.CurrentImageIndexInBuffer]);
      this.saveOptions.indices.forEach((value: any, index: number, arr: any) => {
        value.selected = false;
        if (value.number === this.DWObject.CurrentImageIndexInBuffer)
          value.selected = true;
        arr[index] = value;
      });
    }
  }
  handleIndexSelection(selected: boolean, index: number) {
    let selectedIndices = this.DWObject.SelectedImagesIndices;
    if (selected) {
      selectedIndices.push(index);
    } else {
      selectedIndices.splice(selectedIndices.indexOf(index), 1);
    }
    selectedIndices.sort((a, b) => a - b);
    this.DWObject.SelectImages(selectedIndices);
  }
  handleOutPutFormatChange(format: any) {
    if (format !== "PDF" && format !== "TIF") {
      this.saveOptions.multiPage = false;
      this.handleMultiPageCheck();
    }
  }
  save() {
    this.saveResults.uploadedFiles = [];
    this.saveResults.savedFiles = [];
    this.saveResults.base64String = [];
    this.saveResults.blob = [];
    this.saveResults.blobURL = [];
    this.saveResults.base64ButtonText = [];
    this.saveResults.saveFileText = [];

    this.saveOptions = {
      outPutType: "Blob",
      outPutFormat: "PDF",
      multiPage: false,
      fileName: "Test",
      upload: true,
      buttonText: "Save As Blob",
      indices: [
        {
          number: 0,
          selected: false
        }
      ]
    }

    switch (this.saveOptions.outPutType) {
      case "File":
        if (this.saveOptions.upload) {
          if (this.saveOptions.multiPage) {
            let selectedIndices = this.DWObject.SelectedImagesIndices;
            this.dwtService.uploadToServer(selectedIndices, this.getImageType(this.saveOptions.outPutFormat), this.saveOptions.fileName)
              .then(result => { this.saveResults.uploadedFiles.push(result); this.clearMessage(); }, err => this.showMessage(err));
          }
          else {
            let count = this.DWObject.HowManyImagesInBuffer;
            for (let i = 0; i < count; i++) {
              this.dwtService.uploadToServer([i], this.getImageType(this.saveOptions.outPutFormat), this.saveOptions.fileName + "_" + (i + 1))
                .then(result => { this.saveResults.uploadedFiles.push(result); this.clearMessage(); }, err => this.showMessage(err));
            }
          }
        }
        else if (this.saveOptions.multiPage) {
            let selectedIndices = this.DWObject.SelectedImagesIndices;
            let type = this.getImageType(this.saveOptions.outPutFormat);
            if (type === 2) type = 8;
            if (type === 4) type = 7;
            this.dwtService.saveLocally(selectedIndices, type, this.saveOptions.fileName, true)
              .then(result => {
                this.saveResults.savedFiles.push(result);
                this.saveResults.saveFileText.push("Copy path for " + result.name);
                this.clearMessage();
              }, err => this.showMessage(err));
          }
          else {
            let count = this.DWObject.HowManyImagesInBuffer;
            let fileName = this.saveOptions.fileName + "_" + 1;
            this.dwtService.saveLocally([0], this.getImageType(this.saveOptions.outPutFormat), fileName, true)
              .then(result => {
                this.clearMessage();
                this.saveResults.savedFiles.push(result);
                this.saveResults.saveFileText.push("Copy path for  " + result.name);
                /**
                 * Save more only when the 1st one succeeds!
                 */
                for (let i = 1; i < count; i++) {
                  let fileName = this.saveOptions.fileName + "_" + (i + 1);
                  this.dwtService.saveLocally([i], this.getImageType(this.saveOptions.outPutFormat), fileName, false)
                    .then(result => {
                      this.clearMessage();
                      this.saveResults.savedFiles.push(result);
                      this.saveResults.saveFileText.push("Copy path for  " + result.name);
                    }, err => this.showMessage(err));
                }
                console.log('result', this.saveResults);
              }, err => this.showMessage(err));
          }

        break;
      case "Blob":
        if (this.saveOptions.multiPage) {
          let selectedIndices = this.DWObject.SelectedImagesIndices;
          this.dwtService.getBlob(
            selectedIndices,
            this.getImageType(this.saveOptions.outPutFormat))
            .then(blob => {
              let newFile = new File([blob], "Saved_Blob (" + blob.type + ")", { type: blob.type });
              this.saveResults.blob.push(newFile);
              this.saveResults.blobURL.push(URL.createObjectURL(newFile));
              this.clearMessage();
            }, err => this.showMessage(err));
        } else {
          let count = this.DWObject.HowManyImagesInBuffer;
          this.dwtService.getBlob(
            Array.from(Array(count).keys()),
            this.getImageType(this.saveOptions.outPutFormat))
            .then(blob => {
              let newFile = new File([blob], 'Scan_' + Date.parse(new Date().toString()) + '.pdf', { type: blob.type });
              this.saveResults.blob.push(newFile);
              this.commonService.setScanFiles(this.saveResults);
              this.closePopupEvent.emit()
            }, err => this.showMessage(err));


        }
        break;
      case "Base64":
        if (this.saveOptions.multiPage) {
          let selectedIndices = this.DWObject.SelectedImagesIndices;
          this.dwtService.getBase64(
            selectedIndices,
            this.getImageType(this.saveOptions.outPutFormat))
            .then(base64String => {
              this.saveResults.base64String.push(base64String);
              this.saveResults.base64ButtonText.push("Copy Base64 String");
              this.clearMessage();
            }, err => this.showMessage(err));
        } else {
          let count = this.DWObject.HowManyImagesInBuffer;
          for (let i = 0; i < count; i++) {
            this.dwtService.getBase64(
              [i],
              this.getImageType(this.saveOptions.outPutFormat))
              .then(base64String => {
                this.saveResults.base64String.push(base64String);
                this.saveResults.base64ButtonText.push("Copy Base64 String for image " + i);
                this.clearMessage();
              }, err => this.showMessage(err));
          }
        }
        break;
      default: break;
    }
  }

  copyURLToShow(url: any) {
    if (navigator.clipboard) {
      if (document.hasFocus()) {
        navigator.clipboard?.writeText(url)
          .then(_ => {
            this.showMessage("URL of the blob copied, try paste it in another tab to view it or download the blob as a file. Don't forget to add an extension to the downloaded file before opening it!");
          });

      } else {
        this.showMessage("Can not use the clipboard! Please use HTTPS.");
      }
    }
  }

  performThumbnailUpdate() {
    if (!this.DWObject || this.isUpdatingThumbnails) {
      return;
    }
    this.isUpdatingThumbnails = true;
    try {
      const count = this.DWObject.HowManyImagesInBuffer;
      if (this.thumbnailURLs.length === 0 && count > 0) {
        this.addThumbnail(0);
        return;
      }
      if (count > this.thumbnailURLs.length) {
        for (let i = this.thumbnailURLs.length; i < count; i++) {
          this.addThumbnail(i);
        }
        return;
      }
      if (count < this.thumbnailURLs.length) {
        this.thumbnailURLs = this.thumbnailURLs
          .filter(t => t.index < count)
          .map((t, idx) => ({ ...t, index: idx }));
        this.thumbnailCache.clear();
        this.thumbnailURLs.forEach(t => this.thumbnailCache.set(t.index, t));
      }
    } finally {
      this.isUpdatingThumbnails = false;
    }
  }

  addThumbnail(index: number) {
    if (this.thumbnailCache.has(index)) {
      return;
    }
    const rawUrl = this.DWObject.GetImageURL(index, 200, 200);
    const thumb: ThumbnailItem = {
      id: `thumb_${index}`,
      url: this.sanitizer.bypassSecurityTrustUrl(rawUrl),
      index
    };
    this.thumbnailCache.set(index, thumb);
    this.thumbnailURLs.push(thumb);
  }

  deletePage(index: number, event: MouseEvent) {
    const modalRef = this.modalService.open(ConfirmationPopupComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.header = 'Delete Page';
    modalRef.componentInstance.message = 'Are you sure you want to delete this page';
    modalRef.componentInstance.lableName = 'Delete';
    modalRef.componentInstance.lableCancel = 'Cancel';
    modalRef.componentInstance.isConfirmationMessage = false;
    modalRef.componentInstance.showQuestionMark = true;
    modalRef.componentInstance.showCancelButton = true;
    modalRef.result.then(
      (result: any) => {
        if (result === true || result?.isClose) {
          this.performDelete(index);
        }
      },
      () => {
        event.stopPropagation();
      }
    );
  }

  performDelete(index: number) {
    if (!this.DWObject) {
      return;
    }
    this.DWObject.RemoveImage(index);
    this.thumbnailURLs.splice(index, 1);
    this.thumbnailURLs.forEach((t, i) => {
      t.index = i;
      t.id = `thumb_${i}`;
    });
    this.thumbnailCache.clear();
    this.thumbnailURLs.forEach(t => this.thumbnailCache.set(t.index, t));
    const count = this.DWObject.HowManyImagesInBuffer;
    if (count > 0) {
      this.DWObject.CurrentImageIndexInBuffer =
        Math.min(index, count - 1);
    } else {
      this.emptyBuffer = true;
    }
  }

  selectPage(index: number) {
    if (this.DWObject) {
      this.isSelectingPage = true;
      this.DWObject.CurrentImageIndexInBuffer = index;
      setTimeout(() => {
        this.isSelectingPage = false;
      }, 50);
    }
  }

  saveAsPDF() {
    if (this.DWObject) {
      if (this.DWObject.HowManyImagesInBuffer > 0) {
        this.DWObject.IfShowFileDialog = true;
        this.DWObject.SaveAllAsPDF('ScannedDocument.pdf',
          () => {
            this.showMessage("PDF saved successfully!");
            setTimeout(() => this.clearMessage(), 3000);
          },
          (errorCode, errorString) => {
            console.error('Error saving PDF:', errorString);
            this.showMessage("Error saving PDF: " + errorString);
          }
        );
      } else {
        this.showMessage("There is no image in buffer!");
      }
    }
  }

  onDragStart(event: DragEvent, index: number) {
    this.draggedIndex = index;
    this.isDragging = true;
    if (event.dataTransfer) {
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/html', index.toString());
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = 'move';
    }
  }

  onDrop(event: DragEvent, dropIndex: number) {
    event.preventDefault();
    this.isDragging = false;
    if (
      this.draggedIndex === null ||
      this.draggedIndex === dropIndex ||
      !this.DWObject
    ) {
      this.draggedIndex = null;
      return;
    }
    this.DWObject.MoveImage(this.draggedIndex, dropIndex);
    const movedItem = this.thumbnailURLs.splice(this.draggedIndex, 1)[0];
    this.thumbnailURLs.splice(dropIndex, 0, movedItem);
    this.thumbnailURLs.forEach((t, i) => {
      t.index = i;
      t.id = `thumb_${i}`;
    });
    this.thumbnailCache.clear();
    this.thumbnailURLs.forEach(t => this.thumbnailCache.set(t.index, t));
    this.draggedIndex = null;
  }

  onDragEnd(event: DragEvent) {
    this.isDragging = false;
    this.draggedIndex = null;
  }

  trackByThumbnail(index: number, item: ThumbnailItem): string {
    return item.id;
  }

  scheduleThumbnailUpdate() {
    if (this.thumbnailStableTimeout) {
      clearTimeout(this.thumbnailStableTimeout);
    }
    this.thumbnailStableTimeout = setTimeout(() => {
      requestAnimationFrame(() => {
        this.performThumbnailUpdate();
      });
    }, 300);
  }
}

interface ThumbnailItem {
  id: string;
  url: SafeUrl;
  index: number;
}

interface BarcodeRectToShow {
  x: number;
  y: number;
  w: number;
  h: number;
}

interface Message {
  time: number;
  text: string;
  type: string;
}

interface Zone {
  x: number;
  y: number;
  width: number;
  height: number;
  index: number;
}
